import { Box, Chip, InfoIcon, useTheme } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import React from "react"

// TODO add the Tooltop to this placeholder
export const VirtualServicesTag = () => {
  const theme = useTheme()

  return (
    <Box marginTop={theme.spacing(theme.tokens.spacing.md)}>
      <Chip
        size="small"
        label={
          <Box display="flex" flexDirection="row" alignItems="center">
            <FormattedMessage defaultMessage="Virtual services" />
            &nbsp;
            <InfoIcon color="inherit" fontSize="inherit" />
          </Box>
        }
        sx={{ backgroundColor: theme.palette.success.light }}
      />
    </Box>
  )
}
